import { createContext } from 'react'

import type { createApiService } from '@core/api'

export const ServiceApiContext = createContext<
  ReturnType<typeof createApiService> | undefined
>(undefined)
